import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatisticsQueryService } from '@app/core';
import { SectionHeaderComponent, TimeAgoPipe } from '@app/widgets';
import { TuiAppearance, TuiIcon } from '@taiga-ui/core';
import { TuiPulse } from '@taiga-ui/kit';
import { CountUpModule } from 'ngx-countup';

@Component({
  selector: 'app-app-store-publishing-statistics-section',
  imports: [
    CountUpModule,
    SectionHeaderComponent,
    TimeAgoPipe,
    TuiAppearance,
    TuiIcon,
    TuiPulse,
  ],
  templateUrl: './app-store-publishing-statistics-section.component.html',
  styleUrl: './app-store-publishing-statistics-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppStorePublishingStatisticsSectionComponent {
  protected readonly statistics = this.statisticsQueryService.queryStatistics();

  constructor(
    private readonly statisticsQueryService: StatisticsQueryService,
  ) {}
}
